module.exports = __webpack_public_path__ + "assets/810777154492bac5fb3b9b1a6e133c3e.png";